module.exports = __webpack_public_path__ + "static/24-tyler-f72d32233625dd4f64b18da0069fdec4.jpg";